<div class="modal-dialog" role="document">
  <div class="modal-content border-0">
    <div [ngClass]="['toast-bg-' + type, 'toast-' + type]" class="row" style="border-radius: 2px; min-height: 12px; flex-wrap: unset;">
      <div class="pl-3">
        <i style="padding-top: 22px; padding-bottom: 16px;" [ngClass]="type === TOAST_TYPES.SUCCESS ? ['fa-check-circle', 'toast-icon-' + type]
          : ['fa-info-circle', 'toast-icon-' + type]"
           class="fas fa-align-center"></i>
      </div>
      <span style="padding: 18px 14px; color: #16212F" class="col-9">{{message}}</span>
      <div class="text-center">
        <i 
        style="padding-top: 22px; padding-bottom: 16px; cursor:pointer; color: #5E6980" 
        class="fas fa-times col-1 ml-md-5 float-right" (click)="onClick.emit()"></i>
      </div>
    </div>
  </div>
</div>